module.exports = __webpack_public_path__ + "img/tina_n.4cda61ed.png";